import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ProduktFordelningsmatrisTyper } from "~app/common/models/constants";
import { ProduktDiameterfordelningDTO } from "~app/common/models/produkt/ProduktDiameterfordelningDTO";
import { ProduktLangdfordelningDTO } from "~app/common/models/produkt/ProduktLangdfordelningDTO";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ProduktDetailTexts } from "~app/features/forsaljning/produkt/produkt-detail/produkt-detail.texts";
import { StringFormatPipe } from "../../../../../../../../../common/pipes/string-format.pipe";
import { DiameterfordelningModalValidation } from "./diameterfordelning-modal.validation";

@Component({
    selector: "rask-fordelningsmatris-diameterfordelning-modal",
    templateUrl: "./diameterfordelning-modal.component.html",
    styleUrls: ["./diameterfordelning-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputNumberComponent,
        FormsModule,
        ButtonComponent,
        StringFormatPipe
    ]
})
export class FordelningsmatrisDiameterfordelningModalComponent implements OnInit {
    modal = inject(NgbActiveModal);

    diameterfordelningar: ProduktDiameterfordelningDTO[];
    title: string;
    min: number;
    max: number;
    inputDiameter: number;

    diameter: number;
    validation: IValidationScope;
    validationContext: IValidationContext;

    texts = ProduktDetailTexts.fordelningsmatrisTab.texts;

    get addOrEditButtonText() {
        return this.inputDiameter ? this.texts.andra : this.texts.laggTill;
    }

    get canAdd() {
        return this.validationContext.hasErrors(ValidationScopes.spara);
    }

    ngOnInit(): void {
        this.diameter = this.inputDiameter ? this.inputDiameter : 0;
        this.setupValidation();
    }

    addOrEdit(): void {
        if (this.inputDiameter) {
            const diameterfordelning = this.diameterfordelningar.find(p => p.diamBotten === this.inputDiameter);
            diameterfordelning.diamBotten = this.diameter;
        } else {
            const newDiameter = new ProduktDiameterfordelningDTO();
            newDiameter.diamBotten = this.diameter;
            newDiameter.produktLangdfordelningar = [];
            newDiameter.typ = ProduktFordelningsmatrisTyper.inget;

            if (this.diameterfordelningar[0]) {
                for (const i of this.diameterfordelningar[0].produktLangdfordelningar) {
                    const newLangdfordelning = new ProduktLangdfordelningDTO();
                    newLangdfordelning.andel = 0;
                    newLangdfordelning.langdBotten = i.langdBotten;
                    newLangdfordelning.typ = ProduktFordelningsmatrisTyper.inget;
                    newDiameter.produktLangdfordelningar.push(newLangdfordelning);
                }
            }

            this.diameterfordelningar.push(newDiameter);
        }

        return this.dismiss(true);
    }

    remove(): void {
        const index = this.diameterfordelningar.findIndex(p => p.diamBotten === this.inputDiameter);
        this.diameterfordelningar.splice(index, 1);
        this.dismiss(true);
    }

    dismiss(changesMade: boolean): void {
        if (changesMade) {
            return this.modal.close(changesMade);
        }

        this.modal.dismiss(changesMade);
        return undefined;
    }

    private readonly setupValidation = (): void => {
        this.validationContext = DiameterfordelningModalValidation.init(this.diameter, this.diameterfordelningar, this.min, this.max);
        this.validationContext.scope(ValidationScopes.spara).subscribe(v => this.validation = v);
        this.validationContext.validate();
    };
}
